import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import BusinessSidebar from './BusinessSidebar';
import SEO from '../common/SEO';

const BusinessLayout = ({ title, children }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  if (!user) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="text-slate-600 mt-4">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#f8fafc] flex">
      <SEO
        title={`${title} - Business Dashboard`}
        description="Manage your VMC business dashboard: monitor reviews, respond to feedback, and improve your business trust profile."
      />

      {/* Sidebar */}
      <BusinessSidebar onLogout={handleLogout} />

      {/* Main Content — offset matches sidebar width */}
      <div className="flex-1 ml-[240px] flex flex-col min-h-screen transition-all duration-[280ms]">

        {/* Top bar */}
        <header className="sticky top-0 z-40 flex h-14 items-center justify-between border-b border-slate-200 bg-white/80 backdrop-blur-md px-8">
          <div>
            <h1 className="text-[15px] font-semibold text-slate-800 tracking-tight">
              {title}
            </h1>
          </div>
          <div className="flex items-center gap-4">
            <span className="text-[12px] text-slate-400">
              {new Date().toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' })}
            </span>
            <div className="flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-3 py-1.5">
              <div className="h-5 w-5 rounded-full bg-gradient-to-br from-blue-400 to-indigo-600 flex items-center justify-center text-[10px] font-bold text-white">
                {user?.name?.charAt(0).toUpperCase()}
              </div>
              <span className="text-[12px] font-medium text-slate-700">{user?.name}</span>
              <span className="rounded-full bg-blue-100 px-1.5 py-0.5 text-[10px] font-medium text-blue-600">Business</span>
            </div>
          </div>
        </header>

        {/* Page content */}
        <div className="flex-1 overflow-auto p-8">
          {children}
        </div>
      </div>
    </div>
  );
};

export default BusinessLayout;
